import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';

@Component({
  selector: 'app-filter-product',
  templateUrl: './filter-product.component.html',
  styleUrls: ['./filter-product.component.scss'],
})
export class FilterProductComponent implements OnInit {
  @Output() emitResource = new EventEmitter();
  private _page = 1;
  public products = [];
  public totalPages = undefined;
  public search = '';

  constructor(
    private adminSv: AdminServiceService
  ) { }

  ngOnInit() {
    this.getProducts();
  }

  async getProducts(){
    this.adminSv.getAllProducts(
      this._page,
      this.search
    ).subscribe((res: any) => {
      const data = res.data;
      this.products = data.data;
      this.totalPages = data.meta.last_page;
    })
  }

  showProduct(resourceId){
    this.search = '';
    this.emitResource.emit(resourceId);
  }

  async changePage(ev){
    this._page = ev;
    await this.getProducts();
  }
}
